import SortDirection from '@rio-cloud/rio-uikit/lib/es/SortDirection';

export const getSortDir = (newSortBy, previousSortBy, sortDir) => {
    if (newSortBy === previousSortBy) {
        return sortDir === SortDirection.ASCENDING ? SortDirection.DESCENDING : SortDirection.ASCENDING;
    }
    return SortDirection.ASCENDING;
};
